// removed by extract-text-webpack-plugin
module.exports = {"header":"_1h2q0 _2oaig _28zmO","searchIcon":"_3JX3Z","searchBox":"kWZc_ _3U-gj"};


//////////////////
// WEBPACK FOOTER
// ./components/SearchHeader.css
// module id = 2002
// module chunks = 3